


export const CREATE_INACTIVESHARABLELINKS = "CREATE_INACTIVESHARABLELINKS";   
export const RETRIEVE_INACTIVESHARABLELINKS = "RETRIEVE_INACTIVESHARABLELINKS";
export const RETRIEVESINGLE_INACTIVESHARABLELINKS = "RETRIEVESINGLE_INACTIVESHARABLELINKS";
export const UPDATE_INACTIVESHARABLELINKS = "UPDATE_INACTIVESHARABLELINKS";   
export const DELETE_INACTIVESHARABLELINKS = "DELETE_INACTIVESHARABLELINKS";  